<div class="relative">
  <app-icon-button (click)="monthOpen.set(true)"
    ><p class="font-semibold text-base md:text-lg">
      {{ value() | date: 'MM월' }}
    </p></app-icon-button
  >
  @if (monthOpen()) {
    <app-month-select
      (clickOutside)="monthOpen.set(false)"
      (select)="handleSelectMonth($event)"
      [value]="value()!"
      class="absolute z-[99] left-0 top-[calc(100%+4px)]"
    />
  }
</div>
